import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useRecordHistory } from '@/entities/database';
import { useJournalSearch } from '@/shared/lib/journal-search';
import { SearchField } from '@/shared/ui';

import { describedEvents } from './describe';
import { HistoryList } from './HistoryList';
import styles from './History.module.css';

/**
 * What changed in one record (the same entries as the database's History, narrowed), searchable
 * over the record's whole history - the server filters before it pages.
 */
export function RecordHistory({ recordId, databaseId }: { recordId: string; databaseId: string }) {
  const { t } = useTranslation();
  const catalog = useMemo(() => describedEvents(t), [t]);
  const search = useJournalSearch(catalog);
  const query = useRecordHistory(recordId, true, { q: search.q, types: search.types });
  return (
    <div className={styles.recordHistory}>
      <SearchField
        value={search.input}
        onChange={search.setInput}
        label={t('journal.search')}
        placeholder={t('journal.placeholder')}
        clearLabel={t('journal.clear')}
        testId="record-history-search"
      />
      <HistoryList
        query={query}
        filtered={search.searching}
        databaseId={databaseId}
        recordId={recordId}
      />
    </div>
  );
}
